import React from 'react';
import { View, Text } from '@vectord/ui';

import FcRegisterButton from '../FcRegisterButton';

const RcbStrip = ({ onClose }) => (
  <View
    className="vd-p-24 vd-gap-y-12 sm:vd-gap-x-24 vd-w-full
      vd-bg-surface-neutral-inverse-base vd-items-center vd-justify-between"
    direction="column"
  >
    <View className="vd-flex-col">
      <Text
        color="text-neutral-inverse-primary"
        fontSize="h3"
        weight="bold"
      >
        Learn what lead to these outcomes from Scaler Founder
      </Text>
      <Text
        color="text-neutral-inverse-tertiary"
        fontSize="b3"
        className="vd-mt-2"
      >
        Join Anshuman Singh, for a
        session to explore how Scaler can make a difference for you
      </Text>
    </View>
    <FcRegisterButton
      className="sm:vd-w-1/4 vd-w-full vd-h-full"
      source="banner-video-modal"
      onClose={onClose}
    />
  </View>
);

export default RcbStrip;
